import React from "react";

const Menu = () => 
<svg className="menuIcon" xmlns="http://www.w3.org/2000/svg" width="37" height="26" viewBox="0 0 37 26">
<g id="Group_13258" data-name="Group 13258" transform="translate(-103.809 -62.949)">
  <rect id="Rectangle_5415" data-name="Rectangle 5415" width="36" height="2.777" transform="translate(104.309 63.449)" fill="#fff" stroke="#fff" strokeWidth="1"/>
  <rect id="Rectangle_5416" data-name="Rectangle 5416" width="36" height="2.777" transform="translate(104.309 74.561)" fill="#fff" stroke="#fff" strokeWidth="1"/>
  <rect id="Rectangle_5419" data-name="Rectangle 5419" width="36" height="2.777" transform="translate(104.309 85.672)" fill="#fff" stroke="#fff" strokeWidth="1"/>
</g>
</svg>;

export default Menu;